import request from 'utils/request';

export const fetchToken = () => {
    return request('token', { method: 'POST', data: {} }).then(([body]) => body);
};
